import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'business-issue-field-statistics.sidebar.heading',
		defaultMessage: 'View this list as a chart',
		description:
			'Heading for that sidebar, informing the user this sidebar shows the list as a chart',
	},
	info: {
		id: 'business-issue-field-statistics.sidebar.info',
		defaultMessage: "Select the data you'd like to see in a chart.",
		description: 'Tells the user to select a field to see in the chart',
	},
	close: {
		id: 'business-issue-field-statistics.sidebar.close',
		defaultMessage: 'Close',
		description: 'Tells the user what will happen upon clicking the cross icon',
	},
	selectLabel: {
		id: 'business-issue-field-statistics.sidebar.select-label',
		defaultMessage: 'Field',
		description: 'Label for the select field that the user picks to see displayed in a chart',
	},
});
